import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HeadingSection from '../../components/HeadingSection';
import './style.css';

const ConfigurationLayout = ({
  children,
  match,
  backToLastPath = false,
  headingVisible = true,
  ...props
}) => {
  const { vehname, devname, intersectionName } = match.params;

  return (
    <main className={`configuration-layout heading-visible-${headingVisible}`}>
      {headingVisible && (
        <HeadingSection
          backToLastPath={backToLastPath}
          {...props}
        />
      )}
      {children}
    </main>
  );
};

export default memo(withRouter(ConfigurationLayout));
